let vipsDashboardPreload;

export const preloadVipsDashboard = () => {
  if (!vipsDashboardPreload) {
    vipsDashboardPreload = import("../pages/orders/Orders");
  }
  return vipsDashboardPreload;
};
